module.exports = __webpack_public_path__ + "img/DeadManWalking.77612dd7.png";